import API from './API';

export default {

    findProductCategories() {
        return API.get("/product-categories")
    }

}
